import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import SearchPaging from "./../factories/search-paging";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
function BillingTypeViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.BillingType())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
}
Bao.inherit(BillingTypeViewModel, SearchPaging);
BillingTypeViewModel.prototype.PrimaryKey = "BillingTypeId";
BillingTypeViewModel.prototype.RefreshUrl = "BillingType/Get";
BillingTypeViewModel.prototype.SaveUrl = "BillingType/Save";
BillingTypeViewModel.prototype.DeleteUrl = "BillingType/Delete";
BillingTypeViewModel.prototype.IsInUseUrl = "BillingType/IsInUse";
BillingTypeViewModel.prototype.PermissionForward = "BillingTypeMoveForwardSearch";
BillingTypeViewModel.prototype.PermissionBackward = "BillingTypeMoveBackwardSearch";
BillingTypeViewModel.prototype.PermissionSave = "BillingTypeSave";
BillingTypeViewModel.prototype.PermissionRefresh = "BillingTypeRefresh";
BillingTypeViewModel.prototype.PermissionDelete = "BillingTypeDelete";
export default BillingTypeViewModel;